import React, { createContext, useContext, useEffect, useReducer } from "react";

import { Navigate, useLocation } from "react-router";
import { Outlet } from "react-router-dom";

import JwtDecoder from "../Utils/JwtDecoder/JwtDecoder";

const code = document.cookie
  .split(" ")
  .find((row) => row.startsWith("lang="))
  ?.split("=")[1];

// Define your initial state
const initialState = {
  isLoading: true,
  user: null,
  displayName: "",
  fullName: "",
  email: "",
  isAuthenticated: false,
  otpLength: 6,
  otpDuration: 5 * 60, //5 min -> 5*60 seconds
  lang: {
    cookie: code ? true : false,
    code: code || null,
  },
  expirationTime: null,
  permissions: [],
  role: "",
};

// Create an AuthContext
const AuthContext = createContext();

// Create a reducer to manage state changes
const authReducer = (state, action) => {
  switch (action.type) {
    case "SET_VERIFIED_EMAIL":
      return {
        ...state,
        user: { ...state.user, email: action.payload },
      };
    case "LOGIN":
      return {
        ...state,
        user: action.payload,
        isAuthenticated: true,
      };
    case "LOADING":
      return {
        ...state,
        isLoading: action.payload,
      };
    case "LOGOUT":
      return {
        ...state,
        user: null,
        isAuthenticated: false,
      };
    case "SET_LANG_FROM_COOKIE": {
      return {
        ...state,
        lang: {
          ...state.lang,
          cookie: action.payload && true,
          code: action.payload,
        },
      };
    }
    case "SELECT_LANG": {
      return {
        ...state,
        lang: { ...state.lang, cookie: false, code: action.payload },
      };
    }
    case "SET_COOKIE": {
      const now = new Date();
      const oneMonthLater = new Date(now.getTime() + 30 * 24 * 60 * 60 * 1000); // One month from now

      // Format the expiration date in the required format (GMT string)
      const expires = oneMonthLater.toUTCString();

      document.cookie = `lang=${state.lang.code}; expires=${expires}; path=/;`;
      return state;
    }
    case "SET_TOKEN_PAYLOAD": {
      localStorage.setItem("doctore", action.payload);
      return state;
    }
    case "SET_USER_NAME": {
      localStorage.setItem("UserName", action.payload);
      return { ...state, displayName: action.payload };
    }
    case "SET_USER_DETAILS": {
      return {
        ...state,
        fullName: action?.payload?.name,
        email: action?.payload?.email,
      };
    }
    case "GET_USER_NAME": {
      return { ...state, displayName: localStorage.getItem("UserName") };
    }
    case "SET_JWTDATA": {
      console.log(state.expirationTime);
      const token = localStorage.getItem("doctore");
      if (token) {
        let data = JwtDecoder(token);
        return {
          ...state,
          role: data.roles,
          permissions: loadPermissionToRole(data.roles),
          email: data.email,
          user: data,
          expirationTime: data.exp,
          isAuthenticated: true,
        };
      }
    }
    default:
      return state;
  }
};

let i = 0;
// Create an AuthProvider component
export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, initialState);

  useEffect(() => {
    // readLocalStorage(state, dispatch);
    dispatch({
      type: "SET_JWTDATA",
    });
    dispatch({
      type: "GET_USER_NAME",
    });
  }, [localStorage.getItem("doctore")]);

  useEffect(() => {
    if (state.expirationTime) {
      setTimeout(
        () => {
          localStorage.removeItem("doctore");
          window.location.reload();
        },
        new Date(state.expirationTime * 1000).getTime() - Date.now(),
      );
    }
  }, [state.expirationTime]);

  return (
    <AuthContext.Provider value={{ state, dispatch }}>
      {children}
    </AuthContext.Provider>
  );
};

// Create a custom hook to use the AuthContext
export const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

// Create a protected route
/**
 * this Protected route use cookies for the moment it will change according to
 * requirement
 * @param : children
 */
export const ProtectedRoute = ({ children }) => {
  useExpireChecker();
  let location = useLocation();
  const { state, dispatch } = useAuth();
  if (state.role == "CallAgent" && location.pathname === "/") {
    return <Navigate to={"/doctors"} state={{ from: location }} replace />;
  } else if (state.role == "SuperAdmin" && location.pathname === "/") {
    return <Navigate to={"/overview"} state={{ from: location }} replace />;
  } else {
    return localStorage.getItem("doctore") ? (
      children
    ) : (
      <Navigate
        to={"/signin/select-language"}
        state={{ from: location }}
        replace
      />
    );
  }
};

export const SignInRoute = () => {
  let location = useLocation();
  useExpireChecker();
  return localStorage.getItem("doctore") ? (
    <Navigate to={"/"} state={{ from: location }} replace />
  ) : (
    <Outlet />
  );
};

// this method will check the expiration of JWT key
export const useExpireChecker = () => {
  const { state } = useAuth();
  useEffect(() => {
    const interval = setInterval(() => {
      if (localStorage.getItem("doctore") && state.expirationTime) {
        if (Math.floor(Date.now() / 1000) > state.expirationTime) {
          localStorage.removeItem("doctore");
          window.location.reload();
        }
      }
    }, 5000);

    return () => clearInterval(interval);
  }, [state.expirationTime]);
};

//TODO: this methods will removed
// this method will get localstorage key from web browser
const readLocalStorage = (state, dispatch) => {
  if (localStorage.getItem("doctore") && state.expirationTime !== "") {
    let data = JwtDecoder(localStorage.getItem("doctore"));
    dispatch();
    dispatch({
      type: "REFRESH_TOKEN",
      payload: data,
    });
    dispatch({
      type: "SET_PERMISSION",
      payload: data.roles,
    });
  }
};

//TODO: this methods will removed
// this method will logout the user from system
const logout = (state) => {
  if (localStorage.getItem("doctore") && state.expirationTime) {
    if (
      Math.floor(Date.now() / 1000) > new Date(state.expirationTime).getTime()
    ) {
      localStorage.removeItem("doctore");
    }
  }
};

const loadPermissionToRole = (role) => {
  let superadmin = [
    "overview",
    "finances",
    "dashboard",
    "transaction",
    "doctors",
    "patients",
    "users",
    "payments",
    "consultation-rate",
    "reports",
    "locations"
  ];
  let callcenter = ["finances", "transaction", "doctors", "reports","locations"];
  switch (role) {
    case "SuperAdmin":
      return superadmin;
    case "CallAgent":
      return callcenter;
  }
};

export const UnAuthorizedHandler = ({ permission, children }) => {
  const { state, dispatch } = useAuth();
  if (permissionValidator(state.permissions, permission)) {
    return children;
  } else {
    return <Navigate to={"/no-access"} />;
  }
};

export const permissionValidator = (state, permission) => {
  if (
    localStorage.getItem("doctore") &&
    loadPermissionToRole(
      JwtDecoder(localStorage.getItem("doctore")).roles,
    )?.includes(permission)
  ) {
    return true;
  } else {
    return false;
  }
};
